import React, { useState, Fragment } from "react";

import { IonItem, IonLabel, IonIcon } from "@ionic/react";

import { calendarOutline } from "ionicons/icons";
import { VacancyGrouped } from "../../../interfaces/passage";

import SelectDateModal from "./SelectDate";
import moment from "moment";

interface DatePickerProps {
  date?: string;
  onIonChange: (event: any) => void;
  depature_location_id?: string;
  arrival_location_id?: string;
  onReload?: () => void;
}

const DatePicker: React.FC<DatePickerProps> = ({
  onIonChange,
  date,
  depature_location_id,
  arrival_location_id,
  onReload
}) => {
  const currentDate = moment().format("YYYY-MM-DD");
  const [open, setOpen] = useState(false);
  const onClose = (vacancy: VacancyGrouped | null = null) => {
    setOpen(false);
    if (date === vacancy?.date) {
      if (onReload) onReload();
    }
    onIonChange({
      detail: {
        name: "date",
        value: vacancy?.date
      }
    });
  };
  return (
    <Fragment>
      <IonItem button onClick={() => setOpen(!open)} lines="inset">
        <IonIcon className="icon" slot="start" icon={calendarOutline} />
        <IonLabel>Data</IonLabel>
        <span>{moment(date).format("DD/MM/YYYY")}</span>
      </IonItem>
      {open ? (
        <SelectDateModal
          open={open}
          startAt={currentDate}
          handleClose={onClose}
          selectDate={date}
          arrival_location_id={arrival_location_id}
          departure_location_id={depature_location_id}
        />
      ) : null}
    </Fragment>
  );
};

export default DatePicker;
